import React from 'react';
import { Box, Typography, List, ListItem } from '@mui/material';
import '../Docs.css';   // uses .steps-list and .thumb rules created earlier

export default function SMSWhatsAppSetup() {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h2" gutterBottom>
        SMS&nbsp;&amp;&nbsp;WhatsApp Setup
      </Typography>

      <Typography paragraph>
        Configure your message and confirm Twilio details before sending. All
        merge-fields come from the columns in your data-source.
      </Typography>

      <img
        src="../../static/docs/columnchipbuttons.jpg"
        alt="Select Excel/CSV file"
        className="step-img"
      />

      <List className="steps-vertical" sx={{ marginLeft: "2rem" }}>
        <ListItem sx={{ marginLeft: "1rem" }}>
          <b>From number</b> — must be a&nbsp;Twilio phone number
          linked to your account.
        </ListItem>
        <ListItem sx={{ marginLeft: "1rem" }}>
          <b>To number</b> — merge-field that holds recipients’
          phone numbers (<code>E.164</code> format recommended).
        </ListItem>
        <ListItem sx={{ marginLeft: "1rem" }}>
          <b>Message body</b> — plain text.
          Insert merge-fields for personalisation.
        </ListItem>
        <ListItem sx={{ marginLeft: "1rem" }}>
          <b>WhatsApp campaigns</b> — the same Twilio number must
          be WhatsApp-enabled. <b>If the number is not set to WhatsApp, the campaign will fail.</b>
        </ListItem>
        <ListItem sx={{ marginLeft: "1rem" }}>
          <b>SMS cost &amp; encoding</b> — PostSheet shows an
          estimate of message units and cost per destination country.
        </ListItem>
      </List>

      <img
        src="../../static/docs/smsset.jpg"
        alt="Select Excel/CSV file"
        className="step-img"
      />

      <Typography paragraph sx={{ mt: 2 }}>
        When you click <b>Next</b>, PostSheet
        renders the first few personalised messages and checks Twilio credit
        before scheduling.
      </Typography>
    </Box>
  );
}